import {Component, OnInit} from '@angular/core';
import {NodeBuilder} from "../../../../../../../shared/models";
import { UntypedFormGroup, ReactiveFormsModule } from "@angular/forms";
import {FunctionData, FunctionType, RegularExpression} from "./regular-expression";
import {newStepValue} from "../../../../../services/flowBuilder/utils/constants";
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { ClickatellFormValidationComponent } from '../../../../../../../shared/components/clickatell-form-validation/clickatell-form-validation.component';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';
import { MatSelect, MatOption } from '@angular/material/select';
import { NgTemplateOutlet } from '@angular/common';
import { CMSComponent } from '../../../../../../../shared/components/cms/cms.component';
import { NextSelectorComponent } from '../../../../json-to-from/next-selector/next-selector.component';

const NODE_TYPE = 'regularExpression';

@Component({
    selector: 'app-regular-expression',
    templateUrl: './regular-expression.component.html',
    styleUrls: ['./regular-expression.component.scss'],
    imports: [ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ReactiveFormsModule, ClickatellFormValidationComponent, ActiveFormDirective, MatSelect, MatOption, NgTemplateOutlet, CMSComponent, NextSelectorComponent]
})
export class RegularExpressionComponent extends NodeBuilder implements OnInit {

    readonly functionOptions: string[] = ['match', 'replaceFirst', 'replaceAll']

    regularExpressionForm: UntypedFormGroup
    functionForm: UntypedFormGroup;


    constructor() {
        super(NODE_TYPE);
    }

    ngOnInit(): void {
    }

    set buildForm(stepData: { [index: string]: any }) {
        const regularExpressionForms = RegularExpression.toForm(stepData, this.canEdit);
        this.regularExpressionForm = regularExpressionForms.RegularExpressionFrom;
        this.functionForm = regularExpressionForms.FunctionForm;

        if ( this.regularExpressionForm.get('yes').value === newStepValue) {
            this.regularExpressionForm.get('yes').setValue('step' + this.getNextStep());
        }
        if ( this.regularExpressionForm.get('no').value === newStepValue) {
            this.regularExpressionForm.get('no').setValue('step' + this.getNextStep());
        }
    }

    get getStepData(): {} {
        const formData = this.regularExpressionForm.getRawValue();
        const functionData = this.functionForm.getRawValue();
        return new RegularExpression(formData, functionData).nodeData;
    }

    get isNodeValid(): boolean {
        this.regularExpressionForm.markAllAsTouched();
        this.functionForm.markAllAsTouched();

        return this.regularExpressionForm.valid && this.functionForm.valid;
    }

    public functionChange(functionName: FunctionType) {
        const functionData: FunctionData = {
            replace: '',
            pattern: ''
        }
        this.functionForm = RegularExpression.buildFunctionForm(functionData, functionName, this.canEdit.canEditFlows)
    }
}
